<template>
  <v-container style="padding: 0;">
    <v-btn
      dark
      small
      fab
      @click="showNotification=true"
      :color="notifications.filter(x=>x.status==0).length > 0 ? 'red' : 'primary'"
    >
      <v-icon>notifications</v-icon>
    </v-btn>

    <v-dialog v-model="showNotification" max-width="1000" persistent>
      <v-card-title class="white--text primary py-1 fixedTop" dark>
        <v-layout class="flex align-center">
          <v-flex xs10 md12>
            <v-toolbar-title>{{ headerText }}</v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-btn
              v-if="isAdmin"
              small
              v-show="!addNotification"
              @click="addNotification=true; headerText = 'Add Notification'"
            >Add Notification</v-btn>
          </v-flex>
          <v-flex>
            <v-btn icon small fab @click="updateStatus(1);">
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card v-if="!addNotification">
        <v-card-text v-for="(item, index) in notifications" :key="index">
          <v-layout>
            <v-flex xs8>
              <v-chip v-if="item.status == 0" color="secondary" text-color="white" label small>New</v-chip>
              <v-chip
                v-else-if="item.status == 2"
                color="grey"
                text-color="white"
                label
                small
              >Archived</v-chip>
              <label v-if="!item.link">{{item.header}}</label>
              <a v-else color="primary" :href="item.link" target="_blank">{{item.header}}</a>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs2 class="text-xs-right">
              <label class="caption">{{new Date(item.publishDate).toLocaleDateString("en-AU")}}</label>
            </v-flex>
          </v-layout>

          <v-layout row wrap pa-0 ma-0>
            <v-flex xs8 md10 class="d-flex align-start">
              <v-list-tile-content class="black--text" style="font-size: 14px;">
                <div>
                  {{ readMoreActivated == item.id ? item.content : item.content.slice(0, 225) }}
                  <span
                    v-if="item.content.length > 225"
                  >
                    <v-btn
                      small
                      class="primary"
                      v-if="readMoreActivated !== item.id"
                      @click="activateReadMore(item.id)"
                    >show more</v-btn>
                    <v-btn small class="primary" v-else @click="activateReadMore(0)">show less</v-btn>
                  </span>
                </div>
              </v-list-tile-content>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex v-if="isAdmin">
              <v-btn
                small
                icon
                color="green"
                @click="addNotification=true; edit=true; currentNotification = item; headerText = 'Edit Notification'"
              >
                <v-icon small color="white">edit</v-icon>
              </v-btn>
              <v-btn small icon color="red" @click="removeNotifications(item)">
                <v-icon small color="white">delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card color="light-grey" v-else>
        <v-card-text>
          <v-layout row>
            <v-text-field label="Enter Heading Here" v-model="currentNotification.header"></v-text-field>
            <v-text-field
              prepend-icon="link"
              v-model="currentNotification.link"
              label="Enter link here"
              v-validate="{url: {require_protocol: true }}|'required'"
              data-vv-as="Link"
              name="link"
              data-vv-validate-on="change"
            />
          </v-layout>
          <v-layout row>
            <v-text-field label="Enter text here" v-model="currentNotification.content"></v-text-field>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="editNotification()">Save</v-btn>
          <v-btn
            color="light-grey"
            @click="addNotification=false; currentNotification = {}; headerText = 'Notifications'"
          >Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NotificationsDialog from '@/components/dialogs/notifications-dialog'
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);
const { mapActions: mapNotificationsActions } = createNamespacedHelpers(
  `orders/notifications`
);

export default {
  name: "AppNotifications",
  components: {
    NotificationsDialog
  },
  props: {
    isInDialog: Boolean
  },
  computed: {
    ...mapOrderGetters(["isAdmin"])
  },
  watch: {
    showArchiveNotifications (val) {
      let vm = this;

      if (val) vm.getDealerNotifications();
      else vm.notifications = vm.notifications.filter(s => s.status != 2);
    }
  },
  data () {
    return {
      currentNotification: {
        header: null,
        content: null,
        from: new Date("January 13, 2019 00:00:00"),
        to: new Date("February 13, 2019 00:00:00"),
        link: null,
        status: 0,
        page: 1
      },
      showNotification: false,
      notificationCount: 0,
      addNotification: false,
      edit: false,
      notifications: [],
      showArchiveNotifications: true,
      readMoreActivated: 0,
      headerText: 'Notifications'
    };
  },
  methods: {
    ...mapNotificationsActions([
      "getNotifications",
      "updateNotificationsForDealer",
      "updateNotification",
      "deleteNotification",
      "getNewNotificationCount"
    ]),
    isNew (status) {
      if (status === 0) return true;
      return false;
    },
    getDealerNotifications () {
      let vm = this;
      vm.getNotifications()
        .then(result => {
          vm.notifications = result;
        })
        .catch({});
    },
    updateStatus (status) {
      let vm = this;
      vm.updateNotificationsForDealer(1).then(result => {
        vm.notifications = result;
        vm.showNotification = false;
      });
    },
    editNotification () {
      let vm = this;
      vm.updateNotification(vm.currentNotification).then(result => {
        vm.notifications = result;
      });

      vm.currentNotification = {};
      this.headerText = 'Notifications'
      vm.addNotification = false;
    },
    removeNotifications (notification) {
      let vm = this;

      vm.deleteNotification(notification.id).then(result => {
        vm.notifications = result;
      });
      vm.headerText = 'Notifications'
      // vm.notifications.splice(index, 1);
    },
    setColour (notification) {
      let colour;
      switch (notification.status) {
        case 0:
          colour = "green";
          break;
        case 1:
          colour = "blue";
          break;
        default:
      }
      return colour;
    },
    activateReadMore (id) {
      this.readMoreActivated = id;
    },

  },
  mounted () {
    this.$nextTick(() => {
      let vm = this;
      vm.getDealerNotifications();
    });
  }
};
</script>

<style>
.fixedTop {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>